import {
  HumanizedDateCell,
  TableSelectAllCheckbox,
  TableSelectRowCheckbox,
} from '@/components/ui'
import type { ColumnDef } from '@/components/ui/table/types'
import type { Document } from '@/modules/documents'
import { DocumentCell } from './DocumentCell'
import { NumberOfPagesCell } from './NumberOfPagesCell'
import { RowActionsCell } from './RowActionsCell'
import { StatusCell } from './StatusCell'

const selectColumn = (): ColumnDef<Document, any> => ({
  id: 'select',
  header: TableSelectAllCheckbox,
  cell: TableSelectRowCheckbox,
  enableSorting: false,
  enableHiding: false,
  size: 50,
})

const fileNameColumn = (size = 300): ColumnDef<Document, any> => ({
  accessorKey: 'fileName',
  header: 'Document',
  size,
  meta: { isFluid: true },
  cell: DocumentCell,
})

const createdAtColumn = (): ColumnDef<Document, any> => ({
  accessorKey: 'createdAt',
  header: 'Creation date',
  size: 150,
  cell: HumanizedDateCell,
})

const pagesColumn = (size = 150): ColumnDef<Document, any> => ({
  accessorKey: 'numberOfPages',
  header: '# of Pages',
  size,
  cell: NumberOfPagesCell,
})

const statusColumn = (size = 200): ColumnDef<Document, any> => ({
  accessorKey: 'status',
  header: 'Status',
  size,
  cell: StatusCell,
})

const actionsColumn = (): ColumnDef<Document, any> => ({
  id: 'actions',
  header: '',
  size: 56,
  enableSorting: false,
  enableHiding: false,
  cell: RowActionsCell,
})

export const documentColumns: ColumnDef<Document, any>[] = [
  selectColumn(),
  fileNameColumn(),
  createdAtColumn(),
  pagesColumn(),
  statusColumn(),
  actionsColumn(),
]
